import { render, staticRenderFns } from "./CentralKitchenInfo.vue?vue&type=template&id=53aee384&"
import script from "./CentralKitchenInfo.vue?vue&type=script&lang=js&"
export * from "./CentralKitchenInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports